import styles from "./Text.module.scss"
import cx from "classnames"

const TextField = ({
  field,
  methods,
  error = false,
  className,
  inputClassName,
}) => {
  const { label, placeholder, name } = field
  const { register } = methods

  return (
    <div className={cx(styles.inputWrapper, className)}>
      <label className={styles.label}>{label}</label>
      <input
        className={cx(styles.input, { [styles.error]: error }, inputClassName)}
        type="text"
        placeholder={placeholder ?? ""}
        {...register(name)}
      />
    </div>
  )
}

export default TextField
